import PropTypes from "prop-types";
import { ChevronDown } from "app/icons/navigation";
import "./FilterCollapsible.scss";
import Collapse, { Panel } from "app/components/ui/collapse/Collapse";
import classNames from "classnames";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

export const FilterCollapsible = ({ children, className, ...props }) => {
	const filterCollapsibleClassName = classNames("filter-collapsible", {
		[className]: className?.length > 0,
	});

	return (
		<Collapse
			className={filterCollapsibleClassName}
			accordion={true}
			expandIcon={({ isActive }) => <ChevronDown rotated={isActive} size={24} />}
			{...props}
		>
			{children}
		</Collapse>
	);
};

export const FilterCollapsiblePanel = ({
	title,
	selectedFilter,
	children,
	className,
	...props
}) => {
	const filterCollapsiblePanelClassName = classNames("filter-collapsible-panel", {
		[className]: className?.length > 0,
	});

	return (
		<Panel
			{...props}
			className={filterCollapsiblePanelClassName}
			header={
				<>
					{selectedFilter?.length > 0 && (
						<Typography
							variant={TYPOGRAPHY_VARIANTS.REGULAR}
							component="p"
							className="filter-collapsible-panel__selected-filters"
						>
							{selectedFilter}
						</Typography>
					)}

					{title}
				</>
			}
		>
			{children}
		</Panel>
	);
};

FilterCollapsiblePanel.propTypes = {
	title: PropTypes.node.isRequired,
	selectedFilter: PropTypes.string,
};
